'use client';

import { stripHtml } from '@/lib/homepage-mappers';

interface ProcessSequenceIntroProps {
  heading?: string;
  descriptionHtml?: string;
}

export default function ProcessSequenceIntro({
  heading,
  descriptionHtml,
}: ProcessSequenceIntroProps) {
  const title = heading?.trim();
  const description = descriptionHtml?.trim() ? stripHtml(descriptionHtml) : '';

  if (!title && !description) return null;

  return (
    <section
      data-section-blur="false"
      className="bg-[#F0EDE8] px-6 py-12 sm:px-10 sm:py-14 md:px-12 md:py-16"
      aria-labelledby={title ? 'process-sequence-heading' : undefined}
    >
      <div className="mx-auto max-w-3xl text-center">
        {title ? (
          <h2
            id="process-sequence-heading"
            className="mb-4 text-[clamp(1.5rem,4vw,2.5rem)] font-bold tracking-tight text-[#111111] sm:mb-5"
          >
            {title}
          </h2>
        ) : null}
        {description ? (
          <p className="text-[13px] font-light leading-[1.85] text-black/50 sm:text-sm sm:leading-[1.9]">
            {description}
          </p>
        ) : null}
      </div>
    </section>
  );
}
